import React, {useContext, useEffect, useState} from 'react';
import { Balloon, Checkbox, Input, NumberPicker, Radio, Select } from '@alifd/next';
import {ActivityContext} from '../../index';
import styles from '../../index.module.scss';
let PRIORITY_DATA_SOURCE = []
for (let i=1;i<10;i++) {
  PRIORITY_DATA_SOURCE.push({label:i,value:i})
}
function OtherSetting() {
  const { type, taskParams, setTaskParams, pageDisable, refresh } = useContext(ActivityContext);
  const [adCapChecked ,setAdCapChecked] = useState(false);
  useEffect(()=>{
    if(type!=='create') {
      setAdCapChecked(taskParams.adCap ? true : false);
    }
  },[refresh])
  return (
    <div>
      <div className={styles['cardBox1']}>
        <Balloon.Tooltip
          align='t'
          trigger={<div className={styles['titleBox1']} style={{display:'flex',alignItems:'center'}}>任务优先级<div className={`${styles['iconStyle']} iconfont icon-icon4-33`}/>：</div>}
        >
          任务优先级：1. 多个同类型的任务中，若都包含消费者的同一笔订单，将执行优先级最高的任务；2. 每个优先级在多个同类型任务中只能选择1次，举例说明：若下单关怀A选择了优先级1，则下单关怀B的优先级只能设置2-9其中一个
        </Balloon.Tooltip>
        <Select
          dataSource={PRIORITY_DATA_SOURCE}
          disabled={pageDisable}
          value={taskParams.taskPriority}
          onChange={(v)=>{setTaskParams({...taskParams,taskPriority:v})}}
        />
        <div className={styles['redText']}>数字越小优先级越高</div>
      </div>
      <div className={styles['cardBox1']}>
        <div className={styles['titleBox1']}>
          投放上限：
        </div>
        <Checkbox
          checked={adCapChecked}
          disabled={pageDisable}
          onChange={(v)=>{
            setAdCapChecked(v);
            setTaskParams({
              ...taskParams,
              adCap:0
            })
          }}
        />
        该任务短信发送量累计到达
        <NumberPicker
          disabled={pageDisable || !adCapChecked}
          value={taskParams.adCap ? taskParams.adCap : ''}
          onChange={(v)=>{
            setTaskParams({
              ...taskParams,
              adCap:v ? v : 0
            })
          }}
          hasTrigger={false}
        />
        条时，自动停止任务
        <div className={styles['redText']}>（勾选后，此项为自动停止投放任务的最高优先级判断条件）</div>
      </div>
      <div className={styles['cardBox2']}>
        <div className={styles['putNumBox']}>
          <div className={styles['titleBox1']}>
            投放次数：
          </div>
          <Checkbox
            checked={taskParams.adCnt}
            disabled={pageDisable}
            onChange={(v)=>{
              setTaskParams({
                ...taskParams,
                adCnt:v ? 1 : 0
              })
            }}
          />
          <div>1次 / 消费者 / 天（勾选后，在1天内，消费者若有多笔符合条件的订单仅通知1次，将对下单时间最早的订单投放短信）</div>
        </div>
        <div className={styles['redText']} style={{margin:'6px 0 0 155px',fontSize:'12px'}}>官方频控：1. 在1天之内，每个商家向同一手机号最多可发送5条通知短信；2. 同一手机号在1天之内，最多可接收到15条通知短信</div>
      </div>
      <div className={styles['cardBox1']}>
        <div className={styles['titleBox1']}>
          短信余额不足：
        </div>
        <div>
          <Radio.Group
            value={taskParams.smsSurplusLess}
            onChange={(v) => {
              setTaskParams({
                ...taskParams,
                smsSurplusLess:v
              })
            }}
            disabled={pageDisable}
          >
            <Radio value={0}>
              <div className={styles['radioSmallBox']}>
                关闭任务，充值后需要手动开启任务
              </div>
            </Radio>
            <Radio value={1}>
              <div className={styles['radioSmallBox']}>
                <div>任务保持开启状态，充值后将会自动继续执行此任务；</div>
                <div className={styles['redText']}>注：未补充余额期间内，该任务虽为开启状态，但并不会产生实际的关怀任务</div>
              </div>
            </Radio>
          </Radio.Group>
        </div>
      </div>
    </div>
  );
}

export default OtherSetting;
